export class Timestamp {
  private readonly date: Date;

  private constructor(date: Date) {
    this.date = date;
  }

  static fromDate(date: Date): Timestamp {
    return new Timestamp(new Date(date));
  }

  static now(): Timestamp {
    return new Timestamp(new Date());
  }

  toDate(): Date {
    return new Date(this.date);
  }
}




